export default __webpack_public_path__ + "static/media/nesterov__artem.0c599dee.jpeg";